import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import aqs from "../Images/Icones/AQ 2.png";
import asus from "../Images/asus.jpg";
import "./Styles/carrousel.css"


export const Carrousel = ({carouselAds}) => {
    return (
        <div className="GrandCarou">
            <Carousel showStatus={false} showThumbs={false} autoPlay infiniteLoop>
                {
                    carouselAds.map(x => {
                        if(x.image !== undefined){
                            return (
                                <div className="carou">
                                    <img src={process.env.REACT_APP_ADS_BASE_URL+x.image} className="img1" alt="slider-image"/>
                                </div>
                            )
                        }
                    })
                }

            </Carousel>
        </div>
    )
}